const mixpanelConfig = {
  names: {
    transportRateInfo: 'Check transport info on VDP',
    viewQA: 'View Q&A from VDP',
    viewVHR: 'View vehicle history report',
    placeBid: 'Place bid on a vehicle (5.0)',
    placeBidOmp: 'Bid Placed',
    outbidModal: 'Bidding Against Another Dealer Modal Activated',
    quickBid: 'Quick Bid (5.0)',
    biddingModal: 'Bidding Modal (5.0)',
    proxyBid: 'Set proxy bid (5.0)',
    editProxy: 'Edit proxy bid (5.0)',
    editBid: 'Edit start bid (5.0)',
    viewBidHistory: 'View full bid history',
    watchListTrade: 'Watchlist a trade',
    removeWatchList: 'Remove Watchlist',
    impoundTrade: 'Impound a trade',
    removeImpound: 'Remove Impound',
    openMultiMediaGallery: 'Open MultiMedia Gallery',
    copyVinToClipBoard: 'Copy VIN using clipboard',
    viewDealerProfilePage: 'View dealer profile page',
    viewResearchPageFromVDP: 'Open trade in TR Research from VDP',
    backToListViewFromVDP: 'Back to list view from VDP',
    viewConditionChecklistFromVDP: 'View condition checklist on VDP',
    clickThumbnail: 'Click multimedia gallery thumbnail',
    multimediaNavigation: 'Multimedia navigation',
    viewVehicleDetailsPage: 'View vehicle details page (New VDP)',
    bidError: 'Error while bidding',
    escCloseModal: 'Close modals using Esc button',
    viewFullSpecsFromVDP: 'View full specs & features on VDP',
    vdpNavBarSelection: 'Navigating through VDP nav bar',
    sessionNotValid: 'Session not valid on Web5',
    homeNavigation: 'Home Navigation (5.0)',
    buyingNavigation: 'Buying Navigation (5.0)',
    sellingNavigation: 'Selling Navigation (5.0)',
    researchNavigation: 'Research Navigation (5.0)',
    createNavigation: 'Create Navigation (5.0)',
    vdpOverviewImageInteraction: 'VDP Overview image interaction',
    searchTrade: 'Search for a Trade (5.0)',
    searchUsingShortcut: 'Search using shortcut (5.0)',
    applyFilter: 'Apply filter (5.0)',
    updateFilter: 'Update filter (5.0)',
    createFilter: 'Create filter (5.0)',
    removeFilterPill: 'Filter pills (5.0)',
    selectFilter: 'Select filter from list (5.0)',
    filterNotification: 'Filter Notification (5.0)',
    dealerProfileMenu: 'Dealer Profile Menu (5.0)',
    dgnFilter: 'Network Filter (5.0)',
    sorting: 'Sorting (5.0)',
    selectAlert: 'Select alert (5.0)',
    selectTodo: 'Select todo (5.0)',
    selectGridViewTrade: 'Grid view to mini VDP (5.0)',
    gridViewToggle: 'Grid View Toggle (5.0)',
    tiahLandingPageVisit: 'TIAH landing page visit',
    tiahFindTrustedDealers: 'Find Trusted Dealers',
    tiahEnterPhoneNumber: 'Enter phone number',
    tiahConfirmPhoneNumber: 'Confirm phone number',
    tiahError: 'Phone number authentication errors',
    tiahFilterDealers: 'Filter Dealers on dealer locator',
    tiahPickDealer: 'Pick this dealer on dealer locator',
    initiateRetailVdp: 'Initiate retail VDP',
    generateRetailVdp: 'Generate retail VDP',
    accessRetailVdp: 'Access retail VDP',
    shareRetailVdp: 'Share retail VDP',
    tiahLinkedOpened: 'Retail VDP - TIAH link opened',
    initiateChat: 'Initiate Chat',
    openRetailVdpGallery: 'Retail VDP expanded view',
    clickRetailVdpThumbnail: 'Retail VDP thumbnail click',
    appError: 'App Error (5.0)',
    clickHomePageError: 'Clicked go to homepage button on error page',
    clickDisplayChatError: 'Clicked display chat widget on error page',
    navigateToDMPCheckoutFromNavbar: 'Open Purchases from Nav',
    clickTradeListRefreshButton: 'Clicked button to refetch the TradeList',
    accessRetailToolsPage: 'Access Retail Tools Page',
    retailSettingsFieldsUpdated: 'Retail Settings Fields Updated',
    // Pending
    negotiate: 'Negotiate',
    sendNegotiation: 'Send negotiation modal',
    acceptOffer: 'Accept offer',
    acceptOfferConfirm: 'Accept modal',
    declineOffer: 'Decline offer',
    declineOfferConfirm: 'Yes decline modal',
    stayFirm: 'Stay firm',
    counterOffer: 'Counter offer',
    sendToClosingFromPending: 'Send to Closing',
    sendToClosingFromPendingConfirm: 'Send to Closing modal',
    viewNegotiationHistory: 'View negotiation history',
    replyToOffer: 'Reply to negotiation',
    linkToActiveFromExpired: 'Link to Active from Pending',
    linkToUpcomingFromExpired: 'Link to Upcoming from Pending',
    parkVehicleFromPending: 'Park vehicle from Pending',
    parkVehicleFromPendingConfirm: 'Park modal',
    auctionInDGN: 'Auction in dealer group',
    auctionInDGNConfirm: 'Start auction button',
    sendToLostFromPending: 'Send to Lost',
    sendToLostFromPendingConfirm: 'Move to Lost modal',
    sellerCannotNegotiateDuplicateInDGNError: 'Cannot negotiate yet modal',
    sellerUnusedProxyModalShown: 'Seller Unused Proxy Modal Shown',
    sellerCannotStartDGNNegotiationError: 'Cannot start DGN nego',
    openPaymentsOnHoldPage: 'Open Payments On Hold Page',
    filterPaymentsOnHold: 'Filter Payments On Hold',
    sortPaymentsOnHold: 'Sort Payments On Hold',
    viewDocumentsOwing: 'View Documents Owing',
    fetchAuctionSummary: 'Fetched TradeRev auction summary'
  },
  login: {
    superKeys: {
      REGION: 'region',
      PLATFORM: 'platform',
      APP: 'app',
      APP_VERSION: '$app_version_string',
      ENV: 'environment',
      ENDPOINT: 'endpoint',
      CSU: 'csu',
      LANGUAGE: 'language',
      LAST_LOGIN_WEB: 'last_login_web',
      ISWEB5: 'is_web5',
      SUPERUSER_TYPE: 'superuser_type',
      SUPERUSER_ID: 'superuser_id',
      DEALER_ID: 'dealer_id',
      DEALER: 'dealer',
      DEALER_REGION: 'dealer_region'
    },
    sharedKeys: {
      BILLING_MODEL: 'billing_model'
    },
    peopleKeys: {
      FIRSTNAME: '$first_name',
      LASTNAME: '$last_name',
      DEALER_GROUP: 'dealer_group',
      ROLE: 'role',
      EMAIL: '$email',
      PHONE: '$phone',
      NAME: '$name',
      LAST_LOGIN: 'last_login',
      UUDEALER_ID: 'uudealer_id',
      DISTINCT_ID: '$distinct_id'
    },
    userRoles: {
      isLoader: 'loader',
      isCanBuy: 'can_buy',
      isCanSell: 'can_sell',
      canDeliver: 'can_deliver',
      isBuyerSeller: 'buyer_seller',
      isAccountant: 'accountant'
    },
    userTypes: {
      CLIENTSUPPORTUSER: 'csu',
      UNIVERSALUSER: 'uu'
    }
  },
  regionCode: {
    ca: 1,
    us: 2
  },
  tradeContext: {
    Buying: 'Buy',
    Selling: 'Sell'
  },
  imageOrigin: {
    Overview: 'overview image',
    Disclosure: 'disclosure image'
  },
  source: {
    listView: 'list view',
    searchResults: 'search results',
    dashboardFreshTrades: 'dashboard fresh trades',
    dashboardEventCalendar: 'dashboard event calendar',
    toDoOrAlerts: 'to-do / Alerts',
    menu: 'VDP menu'
  },
  cookieFlag: {
    dashboardFreshTrades: 'dashboard_fresh_trades',
    dashboardEventCalendar: 'dashboard_event_calendar',
    toDoOrAlerts: 'to-do_alerts'
  },
  userType: {
    buyer: 'Buyer',
    seller: 'Seller',
    secondBidder: 'Second Bidder'
  },
  offerType: {
    firstOffer: 'first offer',
    counterOffer: 'counter offer',
    stayFirm: 'stay firm'
  },
  networkType: {
    open: 'Open Network',
    internal: 'Internal network'
  }
};

export default mixpanelConfig;
